import { render } from "./ActivityInfos.vue?vue&type=template&id=924fdfd2&scoped=true"
import script from "./ActivityInfos.vue?vue&type=script&lang=js"
export * from "./ActivityInfos.vue?vue&type=script&lang=js"

import "./ActivityInfos.vue?vue&type=style&index=0&id=924fdfd2&scoped=true&lang=css"

import exportComponent from "C:\\dev-intelij\\MC-production\\widget-vuejs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924fdfd2"]])

export default __exports__